const RATING_TYPE_ORDER = ['CURRENT', 'Long Term', 'Short Term'];

export const formatRatingTypeLabel = (ratingType) => {
  if (!ratingType) return 'Other';
  if (ratingType.toUpperCase() === 'CURRENT') return 'Current';
  return ratingType;
};

export const sortRatingTypes = (types) => {
  return [...types].sort((a, b) => {
    const indexA = RATING_TYPE_ORDER.indexOf(a);
    const indexB = RATING_TYPE_ORDER.indexOf(b);
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.localeCompare(b);
  });
};

export const groupRatingsByType = (ratings) => {
  if (!Array.isArray(ratings) || ratings.length === 0) {
    return {};
  }

  return ratings.reduce((groups, rating) => {
    const type = rating.ratingType || rating.id?.ratingType || 'Other';
    if (!groups[type]) {
      groups[type] = [];
    }
    groups[type].push(rating);
    return groups;
  }, {});
};

export const getRatingRowKey = (rating, index = 0) => {
  if (rating?.id && typeof rating.id === 'object') {
    const { isin, creditRatingAgencyName, creditRatingDate, ratingType } = rating.id;
    return `${isin}-${creditRatingAgencyName}-${creditRatingDate}-${ratingType}`;
  }

  return [
    rating?.isin,
    rating?.creditRatingAgencyName,
    rating?.creditRatingDate,
    rating?.ratingType,
    index,
  ]
    .filter(Boolean)
    .join('-') || `rating-${index}`;
};
